// extracted by mini-css-extract-plugin
export default {"content":"style_content__j1-J3","map":"style_map__4y-S6"};